import { render, staticRenderFns } from "./SearchResultConversationItem.vue?vue&type=template&id=24f569f4&scoped=true&"
import script from "./SearchResultConversationItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultConversationItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultConversationItem.vue?vue&type=style&index=0&id=24f569f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f569f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f569f4')) {
      api.createRecord('24f569f4', component.options)
    } else {
      api.reload('24f569f4', component.options)
    }
    module.hot.accept("./SearchResultConversationItem.vue?vue&type=template&id=24f569f4&scoped=true&", function () {
      api.rerender('24f569f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchResultConversationItem.vue"
export default component.exports